import { CircularProgress } from "material-ui";
import moment from "moment";
import React from "react";
import { Link } from "react-router";

const Loader = () => (
  <div style={{ display: "flex", justifyContent: "center" }}>
    <CircularProgress />
  </div>
);

const SearchPage = ({ webinars, isLoading }) => (
  <div className="section_search_list">
    <div className={`section_search_blurout ${isLoading ? "active" : ""}`}>
      <Loader />
    </div>
    {(webinars || []).length > 0
      ? (webinars || []).map((webinar) => {
          return (
            <Link
              key={webinar.id}
              to={
                webinar.vimeo_url
                  ? `/webinars/${webinar.id}`
                  : `/?scrollTo=${webinar.id}`
              }
              className="searchWebinarItem"
            >
              {moment(webinar.start_date).format("DD/MM/YYYY").toUpperCase()}
              {" - "}
              {webinar.webinar_title}
            </Link>
          );
        })
      : !isLoading && (
          <p style={{ textAlign: "center" }}>
            There are no items matching your query, please search for a
            different keyword.
          </p>
        )}
  </div>
);

export default SearchPage;



// WEBPACK FOOTER //
// ./src/components/SearchPage/SearchPage.jsx